import { render, staticRenderFns } from "./NsHeader.vue?vue&type=template&id=51dfdd40&scoped=true&"
import script from "./NsHeader.vue?vue&type=script&lang=js&"
export * from "./NsHeader.vue?vue&type=script&lang=js&"
import style0 from "./NsHeader.vue?vue&type=style&index=0&id=51dfdd40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dfdd40",
  null
  
)

export default component.exports